import React from 'react';
import './404.css';
import { Button, Text, TextTypes } from '../../components/index';

const NoRouteFound = (props) => {
    const handleGoBack = () => {
        props.history.goBack();
    };

    return (
        <div className="container-404">
            <div>
                <h1 className="four-zero-four">404</h1>
                <hr />
                <Text type={TextTypes.H2}>Oops! page could not be found</Text>
                <br />
                <Button onClick={handleGoBack}> Go Back </Button>
            </div>
        </div>
    );
};

export default NoRouteFound;
